<template>
  <form @submit.prevent="submit" :class="errorClass">
    <rp-textinput
      disabled
      v-model="resource.email"
      placeholder="email"
      />

    <rp-textinput
      disabled
      v-model="resource.first_name"
      placeholder="First Name"
      />

    <rp-textinput
      disabled
      v-model="resource.last_name"
      placeholder="Last Name"
      />

    <rp-textinput
      :isRequired="true"
      v-model="resource.access_code"
      placeholder="Access Code"
      />

    <rp-button :disabled="isInvalid" type="primary">Add nurse</rp-button>
  </form>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {email, required, minLength, maxLength} from 'vuelidate/lib/validators'
  import {date} from '../../../api/validators'
  import {errorMessages} from '../../../api/error_messages'

  import form from '../../../mixins/form'

  import Button from '../../../components/ui/inputs/Button'
  import TextInput from '../../../components/ui/inputs/TextInput'

  export default {
    name: 'PatientForm',
    mixins: [validationMixin, form],

    components: {
      'rp-textinput': TextInput,
      'rp-button': Button
    },

    computed: {
      ...errorMessages([
        'email',
        'first_name',
        'last_name'
        ])
    },

    validations: {
      resource: {
        email: {required, email},
        first_name: {required},
        last_name: {required},
        access_code: {
          required,
          minLength: minLength(5),
          maxLength: maxLength(5),
        },
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/NurseShort.vue